// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__1il28","content":"LoadingAlert_content__18X7e"};